import type { Config } from '@brighterion/types/config';
import axios from 'axios';
import config from './config.dev.json';

export async function getConfig(): Promise<Config> {
    if (process.env.NODE_ENV === 'development') return config as Config;

    // expect config.prod.json to be at the root of the s3 bucket

    const response = await axios.get('/config.prod.json', {
        headers: {
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains'
        }
    });
    const data: Config = await response.data;
    return data;
}
